import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { useForm } from "react-hook-form";
import { AiOutlineSearch } from "react-icons/ai";
import { FaEye } from "react-icons/fa";
import { IoMdArrowBack } from "react-icons/io";
import { SubTitle } from "../../Components/CustomComponents";
import CustomSpinner from "../../Components/CustomComponents/CustomSpinner";
import Table from "../../Components/Table/Table";
import { useGetAllSuperVisorRoutesQuery } from "../../Data/services/supervisorApi";
import { ROUTES } from "./Routes";
import styles from "./styles/index.module.scss";
import ViewStopsModal from "../../Components/Modals/ViewStops";

const SuperVisorRoutes = ({
  setPage,
  setSelectedRow,
  setPageName,
  setSupervisor,
  supervisor,
}) => {
  const { control } = useForm();
  const [indicationMessage, setIndicationMessage] = useState("No Data Found");
  const [viewModal, setViewModal] = useState("");
  const [editedData, setEditedData] = useState("");
  const [editedModal, setEditedModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo
  const [rowData, setRowData] = useState([]);
  const [showImage, setShowImage] = useState(false);

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllSuperVisorRoutesQuery(
      {
        search: searchQuery || "",
        limit: pageSize || 10,
        page: currentPage || 1,
        supervisior_id: supervisor?.id,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      setPageSize(data?.links?.per_page);
      setCurrentPage(data?.links?.current);
      setTotalRecords(data?.links?.total_records);
      setTotalPages(data?.links?.total);
      setRowData(data?.data);
      setDataFetched(true);
    }
    if (data?.data?.length == 0) {
      setIndicationMessage("No Data available");
    }
  }, [data]);
  const handleEditModalOpen = () => {
    setEditedModal(true);
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "route_name",
      text: "Route Name",
      sort: true,
      headerStyle: {
        width: "200px",
      },
    },
    {
      dataField: "total_stops",
      text: "Total Stops",
      // sort: true,
      headerStyle: {
        width: "250px",
      },
    },

    {
      dataField: "remaining_stops",
      text: "Remaining Stops",
      // sort: true,
      headerStyle: {
        width: "250px",
      },
    },
    {
      dataField: "actions",
      text: "Stops",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "150px",
      },
      formatter: (cellContent, row) => {
        if (row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <div
                className={`${styles.btnBg} d-flex justify-content-center align-items-center rounded-3 mx-2 p-2 `}
                role="button"
                onClick={() => {
                  setEditedData(row);
                  setViewModal(true);
                }}
              >
                <span
                  className={`align-items-center d-flex justify-content-center`}
                >
                  <FaEye color="white" />
                </span>
              </div>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {viewModal && (
        <ViewStopsModal
          handleClose={() => setViewModal(false)}
          editData={editedData}
        />
      )}

      <div className={styles.headerContainer}>
        <div className="d-flex justify-content-between w-100">
          <div className="d-flex flex-column gap-3">
            <IoMdArrowBack
              color="black"
              size={25}
              className="cursor-pointer"
              onClick={() => setPage(ROUTES.SUPERVISORS)}
            />
            <SubTitle
              text={`${
                supervisor?.firstname && supervisor?.lastname
                  ? `${supervisor?.firstname} ${supervisor?.lastname}`
                  : supervisor?.name
              } Routes`}
              classes="primary-text"
            />
          </div>
          <div className="d-flex align-items-center gap-2 ms-auto">
            <div className={styles.search}>
              <div className={styles.searchButton}>
                <AiOutlineSearch color="black" />
              </div>

              <input
                type="text"
                placeholder="Search "
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.mainTable}>
        {isLoading ? (
          <CustomSpinner />
        ) : (
          <Table
            data={rowData}
            columns={columns}
            indication={indication}
            totalRecords={totalRecords} // todo
            totalPages={totalPages} // todo
            pageSize={pageSize} // todo
            currentPage={currentPage} // todo
            setCurrentPage={setCurrentPage} // todo
            setPageSize={setPageSize} // todo
            refetch={refetch} // todo
          />
        )}
      </div>
    </div>
  );
};

export default SuperVisorRoutes;
